export type BusinessEntityType = 'PERSON' | 'SOLE_PROPRIETORSHIP' | 'COMPANY';

export interface BusinessEntityAddress {
    street: string;
    city: string;
    postCode: string;
    country: string;
}

export interface PersonBusinessEntity {
    type: 'PERSON';
    data: {
        address: BusinessEntityAddress;
    };
}

export interface SoleProprietorshipBusinessEntity {
    type: 'SOLE_PROPRIETORSHIP';
    data: {
        name: string;
        taxNumber: string;
        regon: string;
        address: BusinessEntityAddress;
        deliveryAddress: BusinessEntityAddress;
    };
}

export interface CompanyBusinessEntity {
    type: 'COMPANY';
    data: {
        name: string;
        taxNumber: string;
        regon: string;
        krs: string;
        districtCourt: string;
        commercialDivision: string;
        address: BusinessEntityAddress;
        deliveryAddress: BusinessEntityAddress;
    };
}

export type BusinessEntity = PersonBusinessEntity | SoleProprietorshipBusinessEntity | CompanyBusinessEntity;

export function emptyAddress(): BusinessEntityAddress {
    return {
        street: '',
        city: '',
        postCode: '',
        country: 'Polska',
    };
}

export function normalizeAddress(raw: any): BusinessEntityAddress {
    return {
        street: String(raw?.street || ''),
        city: String(raw?.city || ''),
        postCode: String(raw?.postCode || ''),
        country: String(raw?.country || 'Polska'),
    };
}

export function isBusinessEntityType(value: unknown): value is BusinessEntityType {
    return value === 'PERSON' || value === 'SOLE_PROPRIETORSHIP' || value === 'COMPANY';
}
